import type { TOC } from '@ember/component/template-only'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { eq } from 'ember-truth-helpers'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Args {
  themeKey?: ThemeKeys
  title?: string
  alert?: boolean
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
  Blocks: {
    default: []
  }
}

export const HomeTile: TOC<Signature> = <template>
  <ContentTile class="border {{if @alert 'border-juicy-orange-400' 'border-dusty-black-100'}}">
    {{#if @title}}
      <div
        class="flex items-center justify-between px-3 py-4
          {{if (eq @themeKey 'blue') 'bg-oceany-blue-50 text-oceany-blue-300'}}
          {{if (eq @themeKey 'green') 'bg-ms-green-50 text-ms-green-300'}}
          {{if (eq @themeKey 'dark-blue') 'bg-wl-blue-50 text-wl-blue-300'}}
          {{if (eq @themeKey 'orange') 'bg-juicy-orange-50 text-dusty-black-300'}}"
      >
        <h4>{{@title}}</h4>
        {{#if @alert}}
          <PhosphorIcon @icon="phosphor-warning-fill" class="text-juicy-orange-400" />
        {{/if}}
      </div>
    {{/if}}
    {{yield}}
  </ContentTile>
</template>

export default HomeTile
